import { render } from "./ProjectsCard.vue?vue&type=template&id=6cc8b2dd&scoped=true"
import script from "./ProjectsCard.vue?vue&type=script&lang=js"
export * from "./ProjectsCard.vue?vue&type=script&lang=js"

import "./ProjectsCard.vue?vue&type=style&index=0&id=6cc8b2dd&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc8b2dd"]])

export default __exports__